import React, { useState, useCallback } from 'react';
import { FormSpy } from 'react-final-form';
import { withStyles } from '@material-ui/core/styles';

import FormTitleBar from '../../core/components/FormTitleBar';
import NavigationPrompt from '../../core/components/NavigationPrompt';
import { removePathEnd, getInitials } from '../../core/utils';
import LeaveConfirm from '../../core/components/LeaveConfirmWrapper';
import { Edit, FormTab, TabbedForm } from 'react-admin';
import EditToolbar from '../../core/components/edit/EditToolbar';

import CategoryTermsSummary from './CategoryTermsSummary';
import CategoryTermsRelations from './CategoryTermsRelations';

const styles = () => ({
  noActions: {
    marginTop: '0px'
  }
});

const CategoryTermsTitle = ({ record }) => {
  return (
    <FormTitleBar
      name={record.title}
      showAvatar
      avatarContent={getInitials(record.title)}
    />
  );
};

const CategoryTermsEdit = props => {
  const {
    classes,
    hasCreatePermission,
    hasEditPermission,
    hasReadPermission,
    hasDeletePermission,
    userProfile,
    ...rest
  } = props;
  const [whenBlockNavigation, setWhenBlockNavigation] = useState(false);

  const handleFormIsDirty = useCallback(
    dirty => {
      // Block navigation when the form is dirty
      setWhenBlockNavigation(dirty);
    },
    [setWhenBlockNavigation]
  );

  const displayToolbar = props.match.isExact;

  return (
    <React.Fragment>
      <NavigationPrompt
        when={whenBlockNavigation}
        adjustMatchingPath={removePathEnd}
        hasEditPermission={hasEditPermission}
      >
        {(isOpen, onConfirm, onCancel) => (
          <LeaveConfirm
            isOpen={isOpen}
            onConfirm={onConfirm}
            onClose={onCancel}
          />
        )}
      </NavigationPrompt>
      <Edit
        {...rest}
        record={{
          description: ''
        }}
        undoable={false}
        title={<CategoryTermsTitle />}
        classes={{ noActions: classes.noActions }}
      >
        <TabbedForm
          toolbar={
            displayToolbar ? (
              <EditToolbar
                {...rest}
                hasEditPermission={hasEditPermission}
                hasDeletePermission={hasDeletePermission}
                //onBeforeDelete={this.onBeforeDelete}
              />
            ) : (
              <></>
            )
          }
          variant="standard"
          margin="normal"
        >
          <FormTab label="Summary">
            <FormSpy
              subscription={{ dirty: true }}
              onChange={props => {
                handleFormIsDirty(props.dirty);
              }}
            />
            <CategoryTermsSummary />
          </FormTab>
          <FormTab label="Related Categories">
            {/** cutting props from the formTab because a fixed width class was given to the child, and making the list smaller*/}
            <>
              <CategoryTermsRelations {...rest} />
            </>
          </FormTab>
        </TabbedForm>
      </Edit>
    </React.Fragment>
  );
};

export default withStyles(styles)(CategoryTermsEdit);
